/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_TimeoutInputs */

const cs_field_timeout = /** @type {(inputs: Field_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Časový limit (s)`)
};

const en_field_timeout = /** @type {(inputs: Field_TimeoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timeout (s)`)
};

/**
* | output |
* | --- |
* | "Timeout (s)" |
*
* @param {Field_TimeoutInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_timeout = /** @type {((inputs?: Field_TimeoutInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_TimeoutInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_timeout(inputs)
	return cs_field_timeout(inputs)
});